/* eslint-disable */
import React, { useRef, useEffect, useState } from 'react';
import {connect} from "react-redux";
import * as createActions from "../../actions/createTrial.js";
import { withRouter } from "react-router";
import { Row, Col, message, Table, Button,Select, Checkbox,Tooltip, Input, Space, Radio,} from "antd";
import { ArrowLeftOutlined, CheckCircleFilled, InfoCircleOutlined,DownOutlined, SearchOutlined } from "@ant-design/icons";
import type { ColumnsType } from 'antd/es/table';
import ReactECharts from 'echarts-for-react';
import { getTrialSoaInsights, getChartsData, saveChartConfiguration, getTrialSBInsights } from "../../utils/ajax-proxy";
import SoaAtGlance from '../../components/SoaAtGlance';
import './index.scss';
import { formatWithCommas, toSentenceCase, convertToHours, displayTimeInHoursOrMins } from '../../utils/utils';
import {  getChartOptions } from '../../utils/common-function';
import { SortOrder } from 'antd/lib/table/interface';
import { getEmail } from "../../utils/auth";
import { DimensionBurdenDataType, SDDimensionBurdenDataType, ActivityUtilizationType, TopActivityType, VisitLevelAnalysisDataType, } from './types.js';
import { useChartTooltip } from 'src/Hooks/useChartTooltip';
import VisitLevelAnalysis from '../../components/VisitLevelAnalysis';

interface Chart {
  id: number;
  name: string;
  description: string;
  selected: boolean;
}

const { Option } = Select;

export const defaultChartData: Chart[] = [
  {
    id: 1,
    name: 'SoA at a glance',
    description: '',
    selected: true
  },
  {
    id: 2,
    name: 'Activities by modality',
    description: '',
    selected: true
  },
  {
    id: 3,
    name: 'Patient burden by activity category',
    description: '',
    selected: false
  },
  {
    id: 4,
    name: 'Patient burden by dimension',
    description: '',
    selected: false
  },
  {
    id: 5,
    name: 'DCT impact on patient burden',
    description: '',
    selected: false
  },
  {
    id: 6,
    name: 'Count of SoA activities by activity category',
    description: '',
    selected: false
  },
  {
    id: 7,
    name: 'Patient burden by visit',
    description: '',
    selected: false
  },
  {
    id: 8,
    name: 'Cost per patient by visit',
    description: '',
    selected: false
  },
  {
    id: 9,
    name: 'Cost per Patient by activity category',
    description: '',
    selected: false
  },
  {
    id: 10,
    name: 'Top activities by cost',
    description: '',
    selected: false
  },
  {
    id: 11,
    name: 'Count of SoA activities by visit',
    description: '',
    selected: false
  },
  {
    id: 12,
    name: "Activity Utilization in Historical Trials",
    description: '',
    selected: false
  },
  {
    id: 13,
    name: "DCT Impact on Site Burden",
    description: '',
    selected: false
  },
 {
    id: 14,
    name: "Site burden by dimension",
    description: "",
    selected: false
  },
  {
    id: 15,
    name: "Time Spent in Trial",
    description: "",
    selected: false
  },
  {
    id: 16,
    name: "Time spent by activity category",
    description: "",
    selected: false
  },
  {
    id: 17,
    name: "Patient Burden by Visit",
    description: "",
    selected: false
  },
  {
    id: 18,
    name: "Time spent by visit",
    description: "",
    selected: false
  },
  {
    id: 20,
    name: 'Site Burden by Activity Category',
    description: '',
    selected: false
  },
];

const ChartSummary = (props:any) => {

  const { location: { state: { trial_id,scenarioId,visits,saveCostChart,modalityOptions,periodDataDetails,visitTypeLib,soaOncologyFlag,soeReadOnly }}} = props;

  const [ DCTonPB, setDCTonPB ] = useState({ pb: { total_dct_pb: 0,total_pb: 0 }, pb_insights_data: []})
  const [ DCTonPBInsightsData, setDCTonPBInsightsData ] = useState([])
  const [ PBbyCategoryInsightsData, setPBbyCategoryInsightsData ] = useState([])
  const [ SBbyCategoryInsightsData, setSBbyCategoryInsightsData ] = useState([])
  const [ costPerPatientByCategoryData, setCostPerPatientbyCategoryData ] = useState([])
  const [ countOfSOAByCategoryData, setCountOfSOAByCategoryData ] = useState([])
  const [ PBVisit, setPBVisit ] = useState( { 
    total_dct_pb_per_visit: [], 
    total_dct_pb: 0, 
    sht_total_pb_median: 0, 
    sht_total_pb_median_first_visit: 0, 
    sht_total_pb_median_visits: 0,
     dct_pb_state: ""})
  const [ TimeSpentByVisitData, setTimeSpentByVisitData ] = useState( { 
    tb_by_visit: [], 
    total_tb: 0, 
    sht_total_tb_median: 0, 
    sht_total_tb_median_first_visit: 0, 
    sht_total_tb_median_subseq_visits: 0,
    tb_state: ""})
 
  const [topActivitiesbyCost, setTopActivitiesbyCost] = useState<TopActivityType[]>([])
  const [loadingSoaAtGlance, setLoadingSoaAtGlance] = useState(true);
  const handleSoALoading = (loading) => {
    setLoadingSoaAtGlance(loading);
  };
  const [SOAByAtGlanceChart, setSOAByAtGlance] = useState({
    pb_insights_data: {
      number_of_activities_soa: 0,
      number_of_activities_median: 0,
      number_of_visits_soa: 0,
      number_of_visits_median: 0,
      patient_burden_soa: 0,
      patient_burden_median: 0,
      cost_soa: 0,
      cost_median: 0,
    },
  });
  const [ costPerVisit, setCostPerVisit ] = useState( { 
    cost_per_state: [], 
    total_cost: 0, 
    sht_total_cost_median: 0, 
    sht_total_cost_median_first_visit: 0, 
    sht_total_cost_median_subseq_visits: 0, 
    cost_state: ""})

    const [ dimensionBurden, setDimensionBurden ] = useState<DimensionBurdenDataType[]>([]);
    const [ activityUtilization, setActivityUtilization] = useState<ActivityUtilizationType[]>([])
    const [ timeSpentInTrial, setTimeSpentInTrial] = useState({
      scenario_time:0,
      historic_time:0
    })
    const [ timeSpentByRole, setTimeSpentByRole] = useState([])
    const [newModalityChartData, setNewModalityChartData] = useState([])
    const [soaActivitiesCount, setsoaActivitiesCount] = useState({
      total_count_per_visit:[],
      total_count: 0,
      sht_total_count_median:0,
      median_count_soa_subsequent_visits:0,
      median_count_soa_first_visit:0,
      count_state:""
    })
    const [ SBVisit, setSBVisit ] = useState({ 
      total_dct_sb_per_visit: [], 
      total_dct_sb: 0, 
      sht_total_sb_median: 0, 
      sht_total_sb_median_first_visit: 0, 
      sht_total_sb_median_visits: 0,
      dct_sb_state: ""
    })


    const [ DCTonSB, setDCTonSB ] = useState({ sb: { total_dct_sb: 0,total_sb: 0 }, sb_insights_data: []})
    const [ DCTonSBInsightsData, setDCTonSBInsightsData ] = useState([])

    const [ sDDimensionBurden, setSDDimensionBurden ] = useState<SDDimensionBurdenDataType[]>([]);

    const [ chartData, setChartData ] = useState<Chart[]>([]);
    const [ isModalOpen, setIsModalOpen ] = useState(false);
    const [pbPerVisit, setpbPerVisit] = useState(false)
    const [sbPerVisit, setsbPerVisit] = useState(false)
    const [patientBurdenTooltipVisible, setPatientBurdenTooltipVisible] = useState(null);
    const [siteBurdenTooltipVisible, setSiteBurdenTooltipVisible] = useState(null);
    const [ visitLevelAnalysisData, setVisitLevelAnalysisData ] = useState<VisitLevelAnalysisDataType[]>([]);
     const [ SBbyCategoryData, setSBbyCategoryData ] = useState([]);

    const modality_options_dict ={
      "eSource & Wearables": { 
        "color": '#FFB600'
      },
      "Telemedicine": { 
        "color": '#3DD5B0'
      },
      "Home Health": { 
        "color": '#295477'
      },
      "Local Lab & Sample Collection": { 
        "color": '#657DFF'
      },
      "Local Clinic": { 
        "color": '#E72B33'
      },
      "IP Direct Shipment": { 
        "color": '#00C6F7'
      },
      "eConsent": { 
        "color": '#299D8F'
      },
      "Traditional Site": { 
        "color":'#D93954'
      },
      "": {
        "icon":'',
        "color":'white'
      }
    }

    useEffect(() => {
      window.scrollTo(0, 0);
      fetchChartData();

      // if (JSON.parse(localStorage.getItem('chartData'))) {
      //   setChartData(JSON.parse(localStorage.getItem('chartData')));
      // } else {
        const getChartSummaryData = async (trial_uuid, ts_id) => {
          const response = await getChartsData(trial_uuid, ts_id + '');
          let idsToRemove = [7, 8, 11, 12, 17, 18, 19];  
          if(response?.length > 0) {
            const chartDataByCategory = soaOncologyFlag ? response.filter(item => !idsToRemove.includes(item.id)) : response.filter(item => item.id !== 19)
            setChartData(chartDataByCategory);
            localStorage.setItem('chartData', JSON.stringify(chartDataByCategory));
            
          } else {
            const chartDataByCategory = soaOncologyFlag ? defaultChartData.filter(item => !idsToRemove.includes(item.id)) : defaultChartData
            localStorage.setItem('chartData', JSON.stringify(chartDataByCategory));
            setChartData(JSON.parse(JSON.stringify(chartDataByCategory)));
          }
        }
        getChartSummaryData(trial_id, localStorage.getItem('ts_id'));
      // }
    }, [props.newSoa?.currentVisitTypes])

    
      
   
    const fetchChartData = async () => {
      const fetchCalls = soaOncologyFlag
        ? [
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "Category", true, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "Dimension", true, false, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "CountOfSOAByCategory", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "dimensionWithHist", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "topActivity", false, false, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "CostPerPatientByCategory", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "SoAatGlance", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "Modality", false, true, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "SiteBurdenDimension", true, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "OHSiteBurdenByDimension", false, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "TimeSpentInTrial", false, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "TimeBurdenByCategory", false, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "SiteBurdenByCategory", true, props.newSoa?.currentVisitTypes),
          ]
        : [
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "Category", true, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "Dimension", true, false, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "CountOfSOAByCategory", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "Visit", false, true, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "TimeSpentByVisit", false, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "CostPerPatientByVisit", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "dimensionWithHist", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "CountOfSoaActivitiesByVisit", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "topActivity", false, false, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "CostPerPatientByCategory", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "SoAatGlance", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "Modality", false, true, props.newSoa?.currentVisitTypes),
            getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "Activity_Utilization", false, true, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "SiteBurdenDimension", true, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "OHSiteBurdenByDimension", false, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "TimeSpentInTrial", false, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "TimeBurdenByCategory", false, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "SiteBurdenVisit", false, props.newSoa?.currentVisitTypes),
            getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "SiteBurdenByCategory", true, props.newSoa?.currentVisitTypes),
          ];
    
      try {
        const results = await Promise.allSettled(fetchCalls);
    
        let category, 
        dimension, 
        countOfSoaCategory, 
        visit, 
        CostPerPatientByVisit, 
        dimensionWithHist, 
        CountOfSoaActivitiesByVisit, 
        topActivity, 
        CostPerPatientByCategory, 
        soaGlance, 
        Modality, 
        activity_utilization, 
        siteBurdenDimension, 
        OHSiteBurdenByDimension, 
        TimeSpentInTrial,
        SiteBurdenVisit,
        TimeBurdenByCategory,
        TimeSpentByVisit,
         SiteBurdenByCategory;

        if (soaOncologyFlag) {
          [
            category,
            dimension,
            countOfSoaCategory,
            dimensionWithHist,
            topActivity,
            CostPerPatientByCategory,
            soaGlance,
            Modality,
            siteBurdenDimension,
            OHSiteBurdenByDimension,
            TimeSpentInTrial,
            TimeBurdenByCategory,
            SiteBurdenByCategory
          ] = results;
        } else {
          [
            category,
            dimension,
            countOfSoaCategory,
            visit,
            TimeSpentByVisit,
            CostPerPatientByVisit,
            dimensionWithHist,
            CountOfSoaActivitiesByVisit,
            topActivity,
            CostPerPatientByCategory,
            soaGlance,
            Modality,
            activity_utilization,
            siteBurdenDimension,
            OHSiteBurdenByDimension,
            TimeSpentInTrial,
            TimeBurdenByCategory,
            SiteBurdenVisit,
            SiteBurdenByCategory
          ] = results;
        }
    
        if (Modality && Modality.status === 'fulfilled' && Object.keys(Modality.value).length !== 0) {
          const modalitySeries = Modality.value['pb_insights_data']['modalities_by_visits'];
          if (modalitySeries) {
            setModalityChartOrgData(modalitySeries);
          }
        } else if (!soaOncologyFlag) {
          message.error('Failed to fetch chart data');
        }
    
        if (soaGlance && soaGlance.status === 'fulfilled' && Object.keys(soaGlance.value).length !== 0) {
          setSOAByAtGlance(soaGlance.value);
        } else if (!soaOncologyFlag) {
          message.error('Failed to fetch chart data');
        }
    
        if (category && category.status === 'fulfilled' && Object.keys(category.value).length !== 0) {
          setPBbyCategoryInsightsData(category.value['pb_insights_data']);
        } else if (!soaOncologyFlag) {
          message.error('Failed to fetch chart data');
        }
    
        if (dimension && dimension.status === 'fulfilled' && Object.keys(dimension.value).length !== 0) {
          const response = dimension.value;
          const insightData = response['pb_insights_data']?.map((item) => item);
          setDCTonPB(response);
          setDCTonPBInsightsData(insightData);
        } else if (!soaOncologyFlag) {
          message.error('Failed to fetch chart data');
        }

        if (siteBurdenDimension && siteBurdenDimension.status === 'fulfilled' && Object.keys(siteBurdenDimension.value).length !== 0) {
          const response = siteBurdenDimension.value;
          const insightData = response['sb_insights_data']?.map((item) => item);
          setDCTonSB(response);
          setDCTonSBInsightsData(insightData);
        } else if (!soaOncologyFlag) {
          message.error('Failed to fetch chart data');
        }
    
        if (countOfSoaCategory && countOfSoaCategory.status === 'fulfilled' && Object.keys(countOfSoaCategory.value).length !== 0) {
          const response = countOfSoaCategory.value;
          setCountOfSOAByCategoryData(response['soa_by_category']);
        } else if (!soaOncologyFlag) {
          message.error('Failed to fetch chart data');
        }

        if (dimensionWithHist && dimensionWithHist.status === 'fulfilled' && Object.keys(dimensionWithHist.value).length !== 0) {
            const response = dimensionWithHist.value
            setDimensionBurden(response['pb_insights_data'])
        }  else if (!soaOncologyFlag)  {
            message.error('Failed to fetch chart data');
        }
    
        if (!soaOncologyFlag) {
          if (visit && visit.status === 'fulfilled' && Object.keys(visit.value).length !== 0) {
            const response = visit.value;
            setPBVisit(response['pb_insights_data']);
          } else {
            message.error('Failed to fetch chart data');
          }

          if(SiteBurdenVisit && SiteBurdenVisit.status === 'fulfilled' && Object.keys(SiteBurdenVisit.value).length !== 0) {  
            const response = SiteBurdenVisit.value;
            setSBVisit(response['sb_insights_data']);
          } else {
            message.error('Failed to fetch chart data');
          }
    
          if (CostPerPatientByVisit && CostPerPatientByVisit.status === 'fulfilled' && Object.keys(CostPerPatientByVisit.value).length !== 0) {
            const response = CostPerPatientByVisit.value;
            setCostPerVisit(response['pb_insights_data']);
          } else {
            message.error('Failed to fetch chart data');
          }

          if (TimeSpentByVisit && TimeSpentByVisit.status === 'fulfilled' && Object.keys(TimeSpentByVisit.value).length !== 0) {
            const response = TimeSpentByVisit.value;
            const sbInsightsData = JSON.parse(JSON.stringify(response['sb_insights_data']))
            sbInsightsData?.tb_by_visit?.forEach(visit => {
              visit.time_burden = convertToHours(visit.time_burden);
            });
            sbInsightsData.sht_total_tb_median_first_visit = convertToHours(sbInsightsData.sht_total_tb_median_first_visit);
            sbInsightsData.sht_total_tb_median_subseq_visits = convertToHours(sbInsightsData.sht_total_tb_median_subseq_visits);      
            setTimeSpentByVisitData(sbInsightsData);
            timeSpentRef.current= sbInsightsData;
          } else {
            message.error('Failed to fetch chart data');
          }
    
          if (CountOfSoaActivitiesByVisit && CountOfSoaActivitiesByVisit.status === 'fulfilled' && Object.keys(CountOfSoaActivitiesByVisit.value).length !== 0) {
            const response = CountOfSoaActivitiesByVisit.value;
            setsoaActivitiesCount(response['pb_insights_data']);
          } else {
            message.error('Failed to fetch chart data');
          }
    
          if (activity_utilization && activity_utilization.status === 'fulfilled' && Object.keys(activity_utilization.value).length !== 0) {
            const response = activity_utilization.value;
            setActivityUtilization(response['pb_insights_data']?.filter(item => item.activity_id !== null));
            setSearchedRawDataActivityUT(response['pb_insights_data']?.filter(item => item.activity_id !== null));
          } else {
            message.error('Failed to fetch chart data');
          }
         
        }
    
        if (topActivity && topActivity.status === 'fulfilled' && Object.keys(topActivity.value).length !== 0) {
          const response = topActivity.value;
          if (response['pb_insights_data'] === null) {
            setTopActivitiesbyCost([]);
          } else {
            setTopActivitiesbyCost(response['pb_insights_data']);
            setSearchedRawDataTopActivity(response['pb_insights_data']);
          }
        } else if (!soaOncologyFlag) {
          message.error('Failed to fetch chart data');
        }

        if (TimeSpentInTrial && TimeSpentInTrial.status === 'fulfilled' && Object.keys(TimeSpentInTrial.value).length !== 0) {
          const response = TimeSpentInTrial.value;
          setTimeSpentInTrial(response['sb_insights_data'][0]?.Patient)
          setTimeSpentByRole(response['sb_insights_data'][1]?.time_burden_by_activity)
        } else {
          message.error('Failed to fetch chart data');
        }

        if (CostPerPatientByCategory && CostPerPatientByCategory.status === 'fulfilled' && Object.keys(CostPerPatientByCategory.value).length !== 0) {
          const response = CostPerPatientByCategory.value;
          setCostPerPatientbyCategoryData(response['pb_insights_data']);
        } else if (!soaOncologyFlag) {
          message.error('Failed to fetch chart data');
        }

        if (OHSiteBurdenByDimension && OHSiteBurdenByDimension.status === 'fulfilled' && Object.keys(OHSiteBurdenByDimension.value).length !== 0) {
          const response = OHSiteBurdenByDimension.value
          setSDDimensionBurden(response['sb_insights_data'])
        }  else {
            message.error('Failed to fetch chart data');
        }

        if (TimeBurdenByCategory && TimeBurdenByCategory.status === 'fulfilled' && Object.keys(TimeBurdenByCategory.value).length !== 0) {
          setSBbyCategoryInsightsData(TimeBurdenByCategory.value['sb_insights_data']);
        } else {
          message.error('Failed to fetch chart data');
        }

        if (SiteBurdenByCategory && SiteBurdenByCategory.status === 'fulfilled' && Object.keys(SiteBurdenByCategory.value).length !== 0) {
          setSBbyCategoryData(SiteBurdenByCategory.value['sb_insights_data']);
        } else  {
          message.error('Failed to fetch Site Burden by category chart data');
        }

      } catch (error) {
        console.error('An error occurred:', error);
      }
    };
    
    const {
      PBbyActivityCategoryOption,
      TimeSpentByVisitOption,
      DCTonPBOption,
      costPatientByCategoryOption,
      countSOAbyCategoryOption,
      visitChartOption,
      costVisitChartOption,
      soaActivitiesChartOption,
      DCTonSBOption,
      TimeByCategoryOption,
      sitevisitChartOption,
      SBbyActivityCategoryOption
    } = getChartOptions(
      PBVisit,
      TimeSpentByVisitData,
      costPerVisit,
      PBbyCategoryInsightsData,
      DCTonPBInsightsData,
      costPerPatientByCategoryData,
      countOfSOAByCategoryData,
      soaActivitiesCount,
      '20%',
      props.newSoa?.currentVisitTypes,
      DCTonSBInsightsData,
      SBbyCategoryInsightsData,
      SBVisit,
      SBbyCategoryData
      )
    
  useEffect(() => {
    const handleScroll = () => {
      setPatientBurdenTooltipVisible(null);
      setSiteBurdenTooltipVisible(null);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const backToHome = () => {
    props.history.push({
      pathname: '/scenario',
      state: {
        trial_id: trial_id,
        scenarioId: scenarioId, 
        visits: visits,
        modalityOptions: modalityOptions,
      }  
    }) 
  }

  const whetherDisplay = (chartName) => {
    const chart = chartData.find((chart: Chart) => chart.name === chartName);        
    if (chart) {
      return chart.selected
    }
  }
 
 
  const columns: ColumnsType<DimensionBurdenDataType> = [
    {
      title: "PB dimension",
      dataIndex: "dimension_name",
      ellipsis: true, 
      width: 220,
      sorter: (a, b) => (a.dimension_name < b.dimension_name ? -1 : 1),
      render: (text, record, index) => {
        const relatedActivities = record.related_activities || [];
        return (
         
          <Tooltip
            title={
              <div className="tooltip-content">
              <strong className="tooltip-title">Related Activities</strong>
              {relatedActivities.length > 0 ? (
                <ul className="tooltip-list custom-tooltip-content">
                  {relatedActivities.map((activity, index) => (
                    <li key={index} className="tooltip-list-item">
                      <span className='hyphen'>-</span>
                      <span className='activity'>{activity}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className='no_data'>No related activity in this scenario</div>
              )}
              </div>
            }
            visible={patientBurdenTooltipVisible === index}
            onVisibleChange={(visible) => setPatientBurdenTooltipVisible(visible ? index : null)}
            trigger="click"
            placement='right'
            overlayInnerStyle={{ backgroundColor: '#f5f5f5', color: 'black', border: '1px solid #d9d9d9', borderRadius: '20%' }}
          >
            <span 
            style={{cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block', maxWidth: '100%'}}
            onClick={() => setPatientBurdenTooltipVisible(patientBurdenTooltipVisible === index ? null : index)}>
              {text}
            </span>
          </Tooltip>
        );
      }
    },
    {
      title: "Scenario value",
      dataIndex: pbPerVisit? "scenario_value_by_visit":"scenario_value",
      ellipsis: true,
      render: item => <span>{formatWithCommas(Math.round(item))}</span>,
      sorter: (a, b) => pbPerVisit ? a.scenario_value_by_visit - b.scenario_value_by_visit : a.scenario_value - b.scenario_value,

    },
    {
      title: "Historical median",
      dataIndex: pbPerVisit ? "historical_median_by_visit" : "historical_median",
      ellipsis: true, 
      render: item => <span>{formatWithCommas(Math.round(item))}</span>,
      sorter: (a, b) => pbPerVisit ? a.historical_median_by_visit - b.historical_median_by_visit : a.historical_median - b.historical_median,
    },
    {
      title: "Difference",
      dataIndex: pbPerVisit ? "difference_by_visit" : "difference",
      ellipsis: true, 
      render: item => <span style={{color: parseInt(item) >= 0 ?  'red' : 'green'}}>{formatWithCommas(Math.round(item))}</span>,
      sorter: (a, b) => pbPerVisit ? Number(a.difference_by_visit) - Number(b.difference_by_visit) : Number(a.difference) - Number(b.difference),
    } 
  ];

  const sDDimensionColumns: ColumnsType<SDDimensionBurdenDataType> = [
    {
      title: "Role",
      dataIndex: "sb_dimension_name",
      ellipsis: true, 
      width: 220,
      sorter: (a, b) => (a.sb_dimension_name < b.sb_dimension_name ? -1 : 1),
      render: (text, record, index) => {
        const relatedActivities = record.related_activities || [];
        return (
         
        <Tooltip
          title={
            <div className="tooltip-content">
            <strong className="tooltip-title">Related Activities</strong>
            {relatedActivities.length > 0 ? (
              <ul className="tooltip-list custom-tooltip-content">
                {relatedActivities.map((activity, index) => (
                  <li key={index} className="tooltip-list-item">
                    <span className='hyphen'>-</span>
                    <span className='activity'>{activity}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <div className='no_data'>No related activity in this scenario</div>
            )}
            </div>
          }
          visible={siteBurdenTooltipVisible === index}
          onVisibleChange={(visible) => setSiteBurdenTooltipVisible(visible ? index : null)}
          trigger="click"
          placement='right'
          overlayInnerStyle={{ backgroundColor: '#f5f5f5', color: 'black', border: '1px solid #d9d9d9', borderRadius: '20%' }}
        >
          <span style={{cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block', maxWidth: '100%'}}
          onClick={() => setSiteBurdenTooltipVisible(siteBurdenTooltipVisible === index ? null : index)}>
            {text}
          </span>
        </Tooltip>
        );
      }
    },
    {
      title: "Scenario value",
      dataIndex: sbPerVisit? "scenario_value_by_visit":"scenario_value",
      ellipsis: true,
      render: item => <span>{Math.round(item)}</span>,
      sorter: (a, b) => sbPerVisit ? a.scenario_value_by_visit - b.scenario_value_by_visit : a.scenario_value - b.scenario_value,
    },
    {
      title: "Historical median",
      dataIndex: sbPerVisit ? "historical_median_by_visit" : "historical_median",
      ellipsis: true, 
      render: item => <span>{Math.round(item)}</span>,
      sorter: (a, b) => sbPerVisit ? a.historical_median_by_visit - b.historical_median_by_visit : a.historical_median - b.historical_median,

    },
    {
      title: "Difference",
      dataIndex: sbPerVisit ? "difference_by_visit" : "difference",
      ellipsis: true, 
      render: item => <span style={{color: parseInt(item) >= 0 ?  'red' : 'green'}}>{Math.round(item)}</span>,
      sorter: (a, b) => pbPerVisit ? Number(a.difference_by_visit) - Number(b.difference_by_visit) : Number(a.difference) - Number(b.difference),

    } 
  ];

  const [searchTextActivityUT, setSearchTextActivityUT] = useState('');
  const [searchedRawDataActivityUT, setSearchedRawDataActivityUT] = useState([]);
  const searchInputActivityUT = useRef(null);

  const handleSearchChangeActivityUT = (event) => {
    const value = event.target.value; 
    setSearchTextActivityUT(value)
    const filtered = [...searchedRawDataActivityUT].filter((record) => {
      const recordValue = record['std_activity'] ? record['std_activity'].toString().toLowerCase() : "";
      return recordValue.includes(value);
    })
    setActivityUtilization(filtered)  
  };

  const activity_utilization_columns:ColumnsType<ActivityUtilizationType> = [
    {
      title: () => (  
        <div>  
          Activity
          <Input 
          placeholder="Search" 
          style={{ 
            width: '100%',
            height: '30px',
            display: 'flex',
            backgroundColor: '#F8F8F8',

          }} 
          onClick={(e) => e.stopPropagation()}
          value={searchTextActivityUT}
          ref={searchInputActivityUT}
          onChange={handleSearchChangeActivityUT}
          prefix={<SearchOutlined style={{
            color: "#666",
            fontSize: 14,
          }}/>}
          />  
        </div>  
      ),
      dataIndex: "std_activity",
      ellipsis: true, 
      width: 220,
      sorter: (a, b) => (a.std_activity < b.std_activity ? -1 : 1),
    },
    {
      title: (  
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>  
         Historical activity frequency  
        </div>  
      ), 
      dataIndex: "historic_activity_frequency",
      ellipsis: true, 
      render: item => <span>{item === null ? '-' : Math.round(item * 100) / 100}</span>,
      sorter: (a, b) => a.historic_activity_frequency - b.historic_activity_frequency, 
    },
    {
      title: (  
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>  
         Historical visit frequency 
        </div>  
      ),  
      dataIndex: "historic_visit_frequency",
      ellipsis: true, 
      render: item => <span>{item===null&&soaOncologyFlag? 'NA' : Math.round(item * 100) / 100}</span>,
      sorter: (a, b) => Number(a.historic_visit_frequency) - Number(b.historic_visit_frequency), 
    },
    {
      title: (  
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>  
        Scenario Visit Frequency
        </div>  
      ), 
      dataIndex: "scenario_visit_frequency",
      ellipsis: true, 
      render: item => <span>{item===null&&soaOncologyFlag? 'NA' : Math.round(item * 100) / 100}</span>,
      sorter: (a, b) => Number(a.scenario_visit_frequency) - Number(b.scenario_visit_frequency), 
    },
    {
      title: "Difference",
      dataIndex: "difference",
      ellipsis: true,
      // render: item => <span style={{color: parseInt(item) >= 0 ?  'red' : 'green'}}>{formatWithCommas(Math.round(item))}</span>,
      render: (item, record) => <span style={{color: (parseInt(record?.historic_visit_frequency) - parseInt(record?.scenario_visit_frequency)) >= 0 ?  'red' : 'green'}}>{record?.historic_visit_frequency===null&&record?.scenario_visit_frequency===null&&soaOncologyFlag? 'NA': Math.round( Number(record?.historic_visit_frequency) - Number(record?.scenario_visit_frequency))}</span>, 
      sorter: (a, b) => (Number(a.historic_visit_frequency) - Number(a.scenario_visit_frequency)) - (Number(b.historic_visit_frequency) - Number(b.scenario_visit_frequency))  
    },
  ];

  const [searchTextTopActivity, setSearchTextTopActivity] = useState('');
  const [searchedRawDataTopActivity, setSearchedRawDataTopActivity] = useState([]);
  const searchInputTopActivity = useRef(null);

  const handleSearchChangeTopActivity = (event) => {
    const value = event.target.value; 
    setSearchTextTopActivity(value)
    const filtered = [...searchedRawDataTopActivity].filter((record) => {
      const recordValue = record['activity'] ? record['activity'].toString().toLowerCase() : "";
      return recordValue.includes(value);
    })
    setTopActivitiesbyCost(filtered)  
  };

  const columnsTopActivity:ColumnsType<TopActivityType> = [
    {
      title: () => (  
        <div>  
          Activity
          <Input 
          placeholder="Search" 
          style={{ 
            width: '100%',
            height: '30px',
            display: 'flex',
            backgroundColor: '#F8F8F8',

          }} 
          onClick={(e) => e.stopPropagation()}
          value={searchTextTopActivity}
          ref={searchInputTopActivity}
          onChange={handleSearchChangeTopActivity}
          prefix={<SearchOutlined style={{
            color: "#666",
            fontSize: 14,
          }}/>}
          />  
        </div>  
      ),  
      dataIndex: "activity",
      ellipsis: true, 
      width: 220,
      sorter: (a, b) => (a.activity < b.activity ? -1 : 1),
    },
    {
      title: "Cost per visit",
      dataIndex: "cost_per_patient",
      ellipsis: true,
      defaultSortOrder: 'descend' as SortOrder,
      render: item => <span>${formatWithCommas(Math.round(item))}</span>,
      sorter: (a, b) => a.cost_per_patient - b.cost_per_patient, 
    },
    {
      title: "Total visits",
      dataIndex: "total_visits",
      ellipsis: true, 
      render: item => <span>{formatWithCommas(Math.round(item))}</span>,
      sorter: (a, b) => a.total_visits - b.total_visits, 
    },
    {
      title: "Total cost",
      dataIndex: "total_cost",
      ellipsis: true, 
      render: item => <span style={{fontWeight: 600}}>${formatWithCommas(Math.round(item))}</span>,
      sorter: (a, b) => a.total_cost - b.total_cost, 
    } 
  ];

  const ActivitymodalityOption = {
    title:{
      show:false,
      text: 'Activities by modality',
      x:'center',
      y:'top',
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#333'
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      confine:false,
      position: ['100%', '-10%']
    },
    grid: {
      left: '10%',
      right: '4%',
      top: '15%',
      bottom: '8%',
      containLabel: true
  },
    xAxis: {
      name: 'Visit number',
      nameLocation: "middle",
      type: 'category',
      data: visits,
      nameRotate: 0, nameGap: 20,
  },
  yAxis: {
      type: 'value'
  },
    series:newModalityChartData
  };

  const time_spent_columns = [
    {
      title: "Activity",
      dataIndex: "std_activity",
      ellipsis: true,
      width: 220,
      sorter: (a, b) => (a.std_activity < b.std_activity ? -1 : 1),
    },
    {
      title: (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>
         Scenario value
        </div>
      ),
      dataIndex: "scenario_time",
      ellipsis: true,
      render: item => <span>{item===null? 'NA' : convertToHours(item)}</span>,
      sorter: (a, b) => a.scenario_time - b.scenario_time,
    },
    {
      title: (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>
        Historical median
        </div>
      ),
      dataIndex: "historic_time",
      ellipsis: true,
      render: item => <span>{item===null? 'NA' : convertToHours(item)}</span>,
      sorter: (a, b) => a.historic_time - b.historic_time,
    },
    {
      title: "Difference",
      dataIndex: "difference",
      ellipsis: true,
      render: (item, record) => <span style={{color: (parseInt(record?.scenario_time) - parseInt(record?.historic_time)) >= 0 ?  'red' : 'green'}}>
        {record?.scenario_time===null&&record?.historic_time===null? 'NA':
          convertToHours(record?.scenario_time - record?.historic_time)}
        </span>,
      sorter: (a, b) => (a.scenario_time - a.historic_time) - (b.scenario_time - b.historic_time)
    },
  ];

  const [currentVisitTypes, setCurrentVisitTypes] = useState("total_trial")
  const [currentVisitIndex, setCurrentVisitIndex] = useState([]);

  const[modalityChartOrgData,setModalityChartOrgData] = useState([])
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const ts_id = localStorage.getItem('ts_id');
  const [selectedCharts, setSelectedCharts] = useState([]);

  useEffect(() => {
    const fetchCustomisedChartData = async (trial_uuid, ts_id) => {
      try {
        const response = await getChartsData(trial_uuid, ts_id + '');
        // Find charts with selected value set to true
        const selectedChartNames = response.filter(chart => chart.selected).map(chart => chart.name);
        setSelectedCharts(selectedChartNames);
      } catch (error) {
        console.error('Error fetching chart data:', error);
      }
    };

    fetchCustomisedChartData(trial_id, localStorage.getItem('ts_id'));
  }, [props.trial_uuid, ts_id]);
  

  useEffect(()=>{
    setCurrentVisitTypes(props.newSoa?.currentVisitTypes)
  },[props.newSoa?.currentVisitTypes])

  const getModalityOptionData = (modalitySeries,currentVisitIndex) => {
    return modalitySeries?.map((item) => ({
       ...item, 
       data: item.data.map((val, index) => {
        return {
          value: val,
          itemStyle: {color: !soaOncologyFlag?modality_options_dict[item.name].color:(currentVisitIndex.includes(index+1)? modality_options_dict[item.name].color:'#DEDEDE')}
        }
       }),
       name: item.name=== 'eConsent'? item.name : toSentenceCase(item.name),
       // color: modality_options_dict[item.name].color, 
       type:"bar",
       stack:"total",
       emphasis:{"focus":"series"}}))
   }

  useEffect(()=>{
    // Get the re-ordered visit array
    let newVisitArray = visits.map((c,i) => c = i + 1)
    // Update the visits array in each period
    let newPeriodType = JSON.parse(JSON.stringify(periodDataDetails))
    let _newVisits = JSON.parse(JSON.stringify(newVisitArray))
    newPeriodType.forEach((period, index) => {
      const visits = _newVisits.splice(0, period.no_of_visits)
      period.visits = visits
    })  
    // Return the current visit array based on the visit type
    let visitArray = []
    if (props.newSoa?.currentVisitTypes === 'total_trial') {
      newPeriodType.forEach((item, index) => {
        visitArray.push(...item?.visits)
      })
    } else {
      newPeriodType.forEach((item, index) => {
        if (item?.visit_type === props.newSoa?.currentVisitTypes) {
          visitArray.push(...item?.visits)
        }
      })
    }
    setCurrentVisitIndex(visitArray)  
    let modality_options = getModalityOptionData(modalityChartOrgData,visitArray)
    setNewModalityChartData(modality_options)  
  },[props.newSoa?.currentVisitTypes, props.newSoa?.soaPeriod_data, periodDataDetails, modalityChartOrgData, visits])

  const handlePeriodType = async(e) => {
    if(!soaOncologyFlag) return
    setCurrentVisitTypes(e)
    props.updateSoaActivities({
      currentVisitTypes: e  
    }) 
    
  }

  const topActivitiesmessage = 'The "Top activities by cost" chart reflects the cost across the entire trial in oncology'

  const getFilterMessage = (v) => {
    switch(v){
      case "total_trial":
        return <span>Metrics for 'Total trial' are estimated using the estimated treatment duration supplied during trial creation.</span>
      case "Screening Visits":
        return <span>Metrics are for Screening visits only.</span>
      case "Fixed Cycle":
        return <span>Metrics apply to only visits within 'Fixed Cycles'.</span>
      case "Repeating Cycle":
        return <span>Metrics apply to only visits within 'Repeating Cycles'.</span>
      case "Follow-up Visits":
        return <span>Metrics are for End of Treatment visits only.</span>
    }
  }
  const formatChartName = (name) => {
    if (name === 'SoA at a Glance') return 'SoA at a glance';
    if (name === 'DCT Impact on Patient Burden') return 'DCT impact on patient burden';
    if (name === 'DCT Impact on OH Site Burden') return 'DCT impact on site burden';
    if (name === 'OH Site burden by dimension') return 'Site burden by dimension';
    if (name.includes('SoA')) {
      return name.split(' ').map((word, index) => word === 'SoA' || index === 0 ? word : word.toLowerCase()).join(' ');
    }
    return toSentenceCase(name);
  };


  const handleChange = (selectedIds) => {
    setSelectedCharts(selectedIds)
    const updatedChartData = chartData.map((chart) => {
      const isSelected = selectedIds.includes(chart.name);
      if (chart.selected !== isSelected) {
        return { ...chart, selected: isSelected };
      }
      return chart;
    });
    setChartData(updatedChartData);
  };

  const saveCustomisedChart = async () => {
    setDropdownOpen(false);
    let chartID = [];
    chartData.forEach((chart: Chart) => {
      if (chart.selected) {
        chartID.push(chart.id);
      }
    });

    const payload = {
      "trial_uuid": trial_id,
      "ts_id": localStorage.getItem('ts_id'),
      "configured_charts": chartID
      // "configured_charts": [chartID[0],chartID[1]]
    };

    const resp = await saveChartConfiguration(payload);
    if (resp && resp.status === "success") {
      message.success('Save successfully');
      localStorage.setItem('chartData', JSON.stringify(chartData));
      const isCustomTabVisible = chartData.some(chart => chart.selected);
      const selectedTab = localStorage.getItem('soaPresetActiveTabKey');
      if (!isCustomTabVisible&&selectedTab==='Custom') {
        localStorage.setItem('soaPresetActiveTabKey', null)
      }
    } else {
      message.error('Failed to save');
    }
  };
  
  const handleCancel = () => {
    setDropdownOpen(false); 
    setChartData(JSON.parse(localStorage.getItem('chartData')));
  };


  const dropdownRender = (menu) => (
    <div>
      <div style={{ maxHeight: '720px', borderBottom: '1px solid #f0f0f0' }}>
      {menu}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: 8 }}>
        <Button 
        size="small" 
        style={{ flex: 1, marginRight: 8, borderColor: 'transparent', color: 'red' }} 
        onClick={handleCancel}>
          Cancel
        </Button>
        <Button 
        type="primary" 
        size="small" 
        style={{ flex: 1, borderColor: 'transparent', color: 'red', background: 'none', boxShadow: 'none'}} 
        onClick={saveCustomisedChart}>
          Create
        </Button>
      </div>
    </div>
  );

  const CustomHeaderWrapper = ({ children }) => {
    return <thead>
      {children}
      {/* {parentRow} */}
      </thead>;
  };

  const [siteTimeTab, setSiteTimeTab] = useState('total_trial');

  const onSiteTimeTabChange = (e) => {
    setSiteTimeTab(e.target.value)
  };

  const [pbSelectedTab, setPbSelectedTab] = useState('pb_totalTrial');
  const [sbSelectedTab, setSbSelectedTab] = useState('sb_totalTrial');

  useEffect(() => {
    setPbSelectedTab('pb_totalTrial');
    setSbSelectedTab('sb_totalTrial');
    setpbPerVisit(false);
    setsbPerVisit(false);
  }, [currentVisitTypes]);

  const handleTabChange = (selectedValue, section) => {
    if (section === 'pb') {
      setPbSelectedTab(selectedValue);
      setpbPerVisit(selectedValue === 'pb_perVisit');
    } else if (section === 'sb') {
      setSbSelectedTab(selectedValue);
      setsbPerVisit(selectedValue === 'sb_perVisit');
    }
  };
  const timeSpentRef = useRef(null);
  const {
    tooltipVisible,
    setTooltipVisible,
    tooltipContent,
    tooltipPosition,
    tooltipRef,
    handleChartClick, 
  } = useChartTooltip();

  const onChartReady = (chart) => {
    chart.on('click', (params) => {
      if (params.componentType === 'markLine') {
        return; 
      }else {
      handleChartClick(params, timeSpentRef.current); 
      }
    });
  };

  return (
    <>
    <Row className="chart-summary-container">
      <Col 
      span={24} 
      style={{backgroundColor: '#DEDEDE', padding: '1% 6% 1%'}}
      >
        <div 
          className="back-btn"
          onClick={backToHome}
        >
          <ArrowLeftOutlined style={{verticalAlign: 'baseline', marginRight: 5,}}/>
          Back
        </div>
        <h3 style={{marginTop: 10, display: 'inline-block'}}>
          SoA impact
        </h3>
        {/* <p className="sub-heading" style={{fontSize: 14, fontFamily: 'Helvetica Neue'}}>Description text goes here</p> */}
      </Col>
      <Col className='configure-chart'> 
        <div className="chart-header"> 
          Create Custom Configuration :
            <br/>
            <div style= {{ position: 'relative',display: 'inline-block', marginBottom: '2px'}}>
            <Select
              mode="multiple"
              style={{ width: '400px'}}
              placeholder= "Select"
              value= {selectedCharts}
              onChange={handleChange}
              dropdownRender={dropdownRender}
              onDropdownVisibleChange={(open) => setDropdownOpen(open)}
              open={dropdownOpen}
              disabled={soeReadOnly}
            >
              
              {chartData.map((chart) => (
                <Option key={chart.id} value={chart.name}>
                  <Checkbox checked={selectedCharts.includes(chart.name)}>
                    {formatChartName(chart.name)}
                  </Checkbox>
                </Option>
              ))}
            
            </Select>
            <DownOutlined 
            style= {{fontSize: '12px',
              position: 'absolute',
              right: '10px', 
              top: '50%',
              transform: 'translateY(-50%)',
              pointerEvents: 'auto', 
              cursor: 'pointer',
            }}
              onClick={() => setDropdownOpen(!dropdownOpen)} />
          </div>
        </div>
      </Col>
      <Col span={24} 
      style={{padding: '1% 6% 1%'}}>
        <div>
                <span style={{fontSize:'22px', marginRight: 40, fontWeight: 500}}>Charts ({chartData.length})</span>
                <div style={{display: 'inline-block'}} onClick={e => e.stopPropagation()}>
                  <label htmlFor="" style={{color:'#000000',marginRight: 15}}>By period type:</label>
                  <Select
                      value={currentVisitTypes.toString()}
                      style={{ width: '250px' }}
                      onChange={handlePeriodType}
                      defaultValue="total_trial"
                  >
                    <Option value="total_trial">Total trial</Option>
                    {soaOncologyFlag && visitTypeLib?.map((item) => (
                      <Option 
                      key={item?.visit_type} 
                      value={item?.visit_type}
                      >
                        {toSentenceCase(item?.visit_type)}
                      </Option>
                    ))}
                  </Select>
                  <Tooltip 
                  overlayInnerStyle={{width: '400px'}}
                  placement="right"
                  title={getFilterMessage(currentVisitTypes)}
                  >
                    <InfoCircleOutlined style={{marginLeft: 10, verticalAlign: 'middle'}}/>
                  </Tooltip>
                </div>
              </div>
      </Col>
      {/* -------  SOA Glance -------- */}
      <Col span={11} className="chart-wrapper"> 
    
        <SoaAtGlance saveCostChart= {saveCostChart} trialId={trial_id} scenarioId={localStorage.getItem('ts_id')} chartData={chartData} whetherSOA={false}
        soaOncologyFlag={soaOncologyFlag}
        currentVisitTypes={currentVisitTypes} onSoALoadingChange={handleSoALoading} soaGlanceData={SOAByAtGlanceChart}/>
      </Col> 
      {/* ------- Visit level analysis -------- */}
      {/* <Col span={11} className="chart-wrapper">
        <div className="chart-header">
            <div className="title">
              Visit level analysis
            </div>
        </div>
      </Col> */}

      {/* -------  Patient burden by activity category-------- */}
      <Col span={11} 
      className={`chart-wrapper ${dimensionBurden?.length > 0 ? 'patient-burden-by-activity-category' : ''}`}
      >
        <div className="chart-header">
          <div className="title">
            Patient burden by activity category
          </div>
          <div className="legend">
            <span>
              <span className="circle" style={{backgroundColor: '#EB8C00'}}></span>
              SoA
            </span>
            <span>
              <span className="circle" style={{backgroundColor: '#FEDACC'}}></span>
              Historical median
            </span>
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Patient Burden by Activity Category')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <ReactECharts 
          style={{height: '400px'}}
          option={PBbyActivityCategoryOption}
          ></ReactECharts> 
        </div>                  
      </Col>

      {/* -------  Patient burden by dimension-------- */}
      <Col span={11} className="chart-wrapper">
        <div className="chart-header">
          <div className="title">
          Patient burden by dimension
          </div>
          <Radio.Group
              value={pbSelectedTab}
              onChange={(e) => handleTabChange(e.target.value, 'pb')}
              className="per-visit-tab"
            >
            <Radio.Button  value="pb_totalTrial">Total Trial</Radio.Button>
            <Radio.Button  value="pb_perVisit">Per Visit</Radio.Button>
          </Radio.Group>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Patient burden by Dimension')?"block":"none"}`}}/>
        </div>
        <div className="chart-container" style={{padding: '5px 18px' }}> 
          <Table
                  columns={columns}
                  dataSource={dimensionBurden} 
                  pagination={{
                    position: ["bottomRight"],
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${dimensionBurden.length} items`,
                    defaultPageSize: 5, 
                  }}  
                />
        </div>                  
      </Col> 

     {/* -------  Patient burden by visit-------- */}
      {!soaOncologyFlag && ( <Col span={11} className="chart-wrapper">
        <div className="chart-header">
          <div className="title">
          Patient burden by visit
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Patient Burden by Visit')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <ReactECharts style={{height: '400px'}} option={visitChartOption}></ReactECharts> 
        </div>                  
      </Col> )}

      {/* -------  DCT impact on patient burden-------- */}
      <Col span={11} className="chart-wrapper dct-impact-on-patient-burden">
        <div className="chart-header">
          <div className="title">
            DCT impact on patient burden
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('DCT Impact on Patient Burden')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <div className="left-part">
            <div className="title-text-plain" style={{fontSize: 14, fontWeight: 600, paddingLeft: 10 }}>DCT impact on patient burden</div>
            <div className="item-wrapper item-wrapper-top">
              <div className="number">
                {formatWithCommas(Math.round(DCTonPB.pb?.total_dct_pb))??'0'}
              </div>
              <div className="text">
                Total patient burden 
                <br/>
                with DCT
              </div>
            </div>
            <div className="item-wrapper item-wrapper-bottom">
              <div className="number">
                {formatWithCommas(Math.round(DCTonPB.pb?.total_pb))??'0'}
              </div>
              <div className="text">
                Total patient burden 
                <br/>
                without DCT
              </div>
            </div>
          </div>
          <div className="middle"> </div>
          <div className="right-part">
            <div className="title" style={{fontWeight: 600}}>
              Patient burden modification by dimension
            </div>
            <div className="chart-content">
            {
             DCTonPBInsightsData && 
             DCTonPBInsightsData.length > 0 &&
             (DCTonPBInsightsData.reduce((accumulator, currentValue) => {
              return accumulator + currentValue.dct_patient_burden;
             }, 0) > 0 || 
             DCTonPBInsightsData.reduce((accumulator, currentValue) => {
              return accumulator + currentValue.patient_burden;
             }, 0) > 0) ? 
                <ReactECharts option={DCTonPBOption}></ReactECharts> : (
                <div className="blank">
                  Based on your current activity and modality selections, none of the patient burden dimensions have a modification in Patient burden due to the application of DCT capabilities. Try adding DCT capabilities to further reduce your patient burden.
                </div>
              )
            } 
            </div>
          </div>
        </div>                  
      </Col>

       {/* ------- Time spent in trial-------- */}
      <Col span={11} className="chart-wrapper">
        <div className="chart-header" style={{flexDirection: 'column'}}>
          <div className="title">
            Time spent in trial
            <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Time Spent in Trial')?"inline-block":"none"}`, float: 'right'}}/>
          </div>
          <div className="others">
            <Radio.Group value={siteTimeTab} onChange={onSiteTimeTabChange} className="site-time-tab" style={{display: 'none'}}>
              <Radio.Button value="total_trial">Total Trial</Radio.Button>
              <Radio.Button value="per_visit">Per Visit</Radio.Button>
            </Radio.Group>
          </div>
          <div className="role-content">
            <div className="left">
              <div className="time">
              {displayTimeInHoursOrMins(timeSpentInTrial?.scenario_time)}
              </div>
              <div className="role">
                Patient
              </div>
            </div>
            <div className="right">
              Median from similar historical trials- <b>{displayTimeInHoursOrMins(timeSpentInTrial?.historic_time)}</b>
            </div>
          </div>
        </div>
        <div className="chart-container" style={{padding: '5px 18px' }}> 
          {
            siteTimeTab === 'total_trial'? (
            <Table
            columns={time_spent_columns}
            dataSource={timeSpentByRole} 
            components={{
              header: {
                wrapper: CustomHeaderWrapper,
              },
            }}
            pagination={{
              position: ["bottomRight"],
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${timeSpentByRole.length} items`,
              defaultPageSize: 5, 
            }} 
          />
            ) : (
              <div></div>
            )
          }
        </div>                  
      </Col>
       
      {/* --------- Time spent by activity category--------- */}
      <Col span={11} 
      className={`chart-wrapper ${dimensionBurden?.length > 0 ? 'time-spent-by-activity-category' : ''}`}
      >
        <div className="chart-header">
          <div className="title">
            Time spent by activity category
          </div>
          <div className="legend">
            <span>
              <span className="circle" style={{backgroundColor: '#EB8C00'}}></span>
              SoA
            </span>
            <span>
              <span className="circle" style={{backgroundColor: '#FEDACC'}}></span>
              Historical median
            </span>
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Time spent by activity category')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <ReactECharts 
          option={TimeByCategoryOption}
          style={{height: '400px'}}
          ></ReactECharts> 
        </div>                  
      </Col>

      {/* --------------Time spent by visit-------------------- */}
      {!soaOncologyFlag && ( <Col span={11} className="chart-wrapper">
        <div className="chart-header">
          <div className="title">
            Time spent by visit
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Time spent by visit')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <ReactECharts 
              style={{height: '400px'}} 
              option={TimeSpentByVisitOption}
              onChartReady={onChartReady}
          >
          </ReactECharts> 
      {tooltipVisible && (
        <div  ref={tooltipRef}>
          <Tooltip
            title={tooltipContent}
            visible={tooltipVisible}
            onVisibleChange={(visible) => setTooltipVisible(visible)}
            overlayClassName="tooltip-overlay"
            overlayInnerStyle={{
              maxHeight: '180px',  
              overflowY: 'auto',
              backgroundColor: '#ffffff',
              color: '#000000',
              borderRadius: '5px',
              width:'420px'
            }}
          >
            <div 
            className='tooltip-target'
            style={{  left: tooltipPosition.x, top: tooltipPosition.y}} />
          </Tooltip>
        </div>
      )}
        </div>                  
      </Col> )}

       {/* -------  Site burden by activity category-------- */}
      <Col span={11} 
      className="chart-wrapper"
      >
        <div className="chart-header">
          <div className="title">
            Site burden by activity category
          </div>
          <div className="legend">
            <span>
              <span className="circle" style={{backgroundColor: '#EB8C00'}}></span>
              SoA
            </span>
            <span>
              <span className="circle" style={{backgroundColor: '#FEDACC'}}></span>
              Historical median
            </span>
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Site Burden by Activity Category')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <ReactECharts 
          style={{height: '400px'}}
          option={SBbyActivityCategoryOption}
          ></ReactECharts> 
        </div>                  
      </Col>

      {/* --------------- Site Burden by visit-------- */}
      {!soaOncologyFlag && ( <Col span={11} className="chart-wrapper">
        <div className="chart-header">
          <div className="title">
          Site burden by visit
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Site Burden by Visit')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <ReactECharts style={{height: '400px'}} option={sitevisitChartOption}></ReactECharts> 
        </div>                  
        </Col> )}

      
      {/*------------ DCT impact on site burden----- */}
      <Col span={11} className="chart-wrapper dct-impact-on-patient-burden">
        <div className="chart-header">
          <div className="title">
            DCT impact on site burden
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('DCT Impact on OH Site Burden')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <div className="left-part">
            <div className="title-text-plain" style={{fontSize: 14, fontWeight: 600, paddingLeft: 10 }}>DCT impact on site burden</div>
            <div className="item-wrapper item-wrapper-top">
              <div className="number">
                {formatWithCommas(Math.round(DCTonSB.sb?.total_dct_sb))??'0'}
              </div>
              <div className="text">
                Total site burden 
                <br/>
                with DCT
              </div>
            </div>
            <div className="item-wrapper item-wrapper-bottom">
              <div className="number">
                {formatWithCommas(Math.round(DCTonSB.sb?.total_sb))??'0'}
              </div>
              <div className="text">
                Total site burden 
                <br/>
                without DCT
              </div>
            </div>
          </div>
          <div className="middle"> </div>
          <div className="right-part">
            <div className="title" style={{fontWeight: 600}}>
              Site burden modification by dimension
            </div>
            <div className="chart-content">
            {
             DCTonSBInsightsData&&DCTonSBInsightsData.length > 0 && DCTonSBInsightsData.reduce((accumulator, currentValue) => {
              return accumulator + currentValue.oh_dct_site_burden;
            }, 0) > 0 ? 
                <ReactECharts option={DCTonSBOption}></ReactECharts> : (
                <div className="blank">
                  Based on your current activity and modality selections, none of the site burden dimensions have a modification in site burden due to the application of DCT capabilities. Try adding DCT capabilities to further reduce your site burden.
                </div>
              )
            } 
            </div>
          </div>
        </div>                  
      </Col>

      {/* ---------- Site burden dimension------ */}
      <Col span={11} className="chart-wrapper">
        <div className="chart-header">
          <div className="title">
          Site burden by dimension
          </div>
          <Radio.Group
          value={sbSelectedTab}
          onChange={(e) => handleTabChange(e.target.value, 'sb')}
          className="per-visit-tab"
          >
            <Radio.Button  value="sb_totalTrial">Total Trial</Radio.Button>
            <Radio.Button  value="sb_perVisit">Per Visit</Radio.Button>
          </Radio.Group>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('OH Site burden by dimension')?"block":"none"}`}}/>
        </div>
        <div className="chart-container" style={{padding: '5px 18px' }}> 
          <Table
                  columns={sDDimensionColumns}
                  dataSource={sDDimensionBurden} 
                  pagination={{
                    position: ["bottomRight"],
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${sDDimensionBurden.length} items`,
                    defaultPageSize: 5, 
                  }}  
                />
        </div>                  
      </Col> 

      {/* ------ Top activities by cost ------ */}
      <Col span={11} className="chart-wrapper">
        <div className="chart-header">
          <div className="title">
          Top activities by cost
          {soaOncologyFlag &&
          <Tooltip 
              overlayInnerStyle={{width: '400px'}}
              placement="right"
                        // visible={true}
              title={topActivitiesmessage}
              >
                <InfoCircleOutlined style={{marginLeft: 10, verticalAlign: 'middle', marginTop: -2}}/>
          </Tooltip>
          }
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Top Activities by Cost')?"block":"none"}`}}/>
        </div>
        <div className="chart-container" style={{padding: '5px 18px' }}> 
          <Table
            columns={columnsTopActivity}
            dataSource={topActivitiesbyCost} 
            pagination={{
              position: ["bottomRight"],
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${topActivitiesbyCost.length} items`,
              defaultPageSize: 5, 
            }}  
          />
        </div>                  
      </Col> 

      {/* ------ Cost per patient by Activity chart ------ */}
      <Col span={11} className="chart-wrapper cost-patient-by-activity-category">
        <div className="chart-header">
          <div className="title">
            Cost per patient by activity category
          </div>
          <div className="legend">
            <span>
              <span className="circle" style={{backgroundColor: '#EB8C00'}}></span>
              SoA
            </span>
            <span>
              <span className="circle" style={{backgroundColor: '#FEDACC'}}></span>
              Historical median
            </span>
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Cost per Patient by Activity Category')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <ReactECharts option={costPatientByCategoryOption}style={{  height: '400px'}}></ReactECharts> 
        </div>                  
      </Col>

        {/* ------- Cost per patient by visit chart -----------*/}
        {!soaOncologyFlag && ( <Col span={11} className="chart-wrapper">
        <div className="chart-header">
          <div className="title">
          Cost per patient by visit
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Cost per Patient by Visit')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <ReactECharts style={{height: '400px'}} option={costVisitChartOption}></ReactECharts> 
        </div>                  
      </Col>)}

      {/*----------- Activity Utilization---------  */}
      {!soaOncologyFlag && ( <Col span={11} className="chart-wrapper">
        <div className="chart-header">
          <div className="title">
          Activity utilization in historical trials
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Activity Utilization in Historical Trials')?"block":"none"}`}}/>
        </div>
        <div className="chart-container" style={{padding: '5px 18px' }}> 
          <Table
                  columns={activity_utilization_columns}
                  dataSource={activityUtilization} 
                  pagination={{
                    position: ["bottomRight"],
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${activityUtilization.length} items`,
                    defaultPageSize: 5, 
                  }}  
                />
        </div>                  
      </Col> )}

      {/* -------------- Activities by Modality Chart--------- */}
      <Col span={11} className="chart-wrapper">
        <div className="chart-header">
          <div className="title">
            Activities by modality
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Activities by Modality')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
            <ReactECharts option={ActivitymodalityOption} style={{ width: '80%',  height: '400px'}}/>
        </div>
      </Col>

      {/* -------------- Count of SoA activities by activity category-------------------- */}
      <Col span={11} className="chart-wrapper count-soa-by-activity-category">
        <div className="chart-header">
          <div className="title">
            Count of SoA activities by activity category
          </div>
          <div className="legend">
            <span>
              <span className="circle" style={{backgroundColor: '#EB8C00'}}></span>
              SoA
            </span>
            <span>
              <span className="circle" style={{backgroundColor: '#FEDACC'}}></span>
              Historical median
            </span>
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Count of SoA Activities by Activity Category')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <ReactECharts 
          style={{height: '400px'}}
          option={countSOAbyCategoryOption}
          ></ReactECharts> 
        </div>                  
      </Col>

      {/* ------  Count of SoA activities by visit ------ */}
      {!soaOncologyFlag && (<Col span={11} className="chart-wrapper">
        <div className="chart-header">
          <div className="title">
          Count of SoA activities by visit
          </div>
          <CheckCircleFilled style={{color: '#97E095', display: `${whetherDisplay('Count of SoA Activities by Visit')?"block":"none"}`}}/>
        </div>
        <div className="chart-container">
          <ReactECharts style={{height: '400px'}} option={soaActivitiesChartOption}></ReactECharts> 
        </div>                  
      </Col>)}

  </Row>
  </>
  )
}
const mapDispatchToProps = (dispatch) => ({
  createTrial: (val) => dispatch(createActions.createTrial(val)),
  createSoa: (val) => dispatch(createActions.createSoa(val)),
  updateSoaActivities: (val) => dispatch(createActions.updateSoaActivities(val)),
});

const mapStateToProps = (state) => ({
  newTrial: state.trialReducer,
  newSoa: state.soaReducer,
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChartSummary));